import { render } from "./RecentGames.vue?vue&type=template&id=49045782&scoped=true"
import script from "./RecentGames.vue?vue&type=script&lang=js"
export * from "./RecentGames.vue?vue&type=script&lang=js"

import "./RecentGames.vue?vue&type=style&index=0&id=49045782&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49045782"]])

export default __exports__